import { useMemo, useState } from 'react';
import { round } from 'lodash';
import styled from 'styled-components';

import SingleSlider from 'components/inputs/SingleSlider';
import { formatPercentageInteger } from 'utils/numberFormatter';

const SLIDER_MAX = 100;
const SLIDER_STEP = 1;

const StyledSingleSlider = styled(SingleSlider)`
  & .MuiSlider-valueLabelOpen {
    top: 0;
  }
`;

interface Props {
  buyerFee: number;
  sellerFee: number;
  minFeePercent: number;
  onChange: (value: number) => void;
}

const FeeSlider = ({ buyerFee, sellerFee, minFeePercent, onChange }: Props) => {
  const [sliderValue, setSliderValue] = useState<number>(calculatePercentage(buyerFee, sellerFee));

  const resolveLabel = (value: number) => formatPercentageInteger(value);

  const handleChange = (value: number) => onChange(calculateValue(buyerFee, sellerFee, value));

  const sliderMin = useMemo(() => Math.min(minFeePercent, calculatePercentage(buyerFee, sellerFee)), []);

  return (
    <StyledSingleSlider
      min={sliderMin}
      max={SLIDER_MAX}
      step={SLIDER_STEP}
      value={sliderValue}
      resolveLabel={resolveLabel}
      onChange={setSliderValue}
      onChangeCommitted={handleChange}
    />
  );
};

const calculatePercentage = (buyerFee: number, sellerFee: number) => {
  const totalFee = buyerFee + sellerFee;
  return round((buyerFee * 100) / totalFee, 0);
};

const calculateValue = (buyerFee: number, sellerFee: number, value: number) => {
  const totalFee = buyerFee + sellerFee;
  return round((totalFee * value) / 100, 2);
};

export default FeeSlider;
